import type { NotificationGetNotifications200NotificationsItemSourceSourceUserAllOf } from './notificationGetNotifications200NotificationsItemSourceSourceUserAllOf';
import type { NotificationGetNotifications200NotificationsItemSourceSourceUserAllOfTwo } from './notificationGetNotifications200NotificationsItemSourceSourceUserAllOfTwo';

/**
 * 알림을 발생시킨 사용자 정보
 */
export type NotificationGetNotifications200NotificationsItemSourceSourceUser = NotificationGetNotifications200NotificationsItemSourceSourceUserAllOf & NotificationGetNotifications200NotificationsItemSourceSourceUserAllOfTwo;
